import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthenticatedHomeGate"] */ "/app/src/components/index/sections/hero/AuthenticatedHomeGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CombinedPortfolioSection"] */ "/app/src/components/index/sections/hero/CombinedPortfolioSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingAuthPanel"] */ "/app/src/components/index/sections/hero/LandingAuthPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyWatchDogPreview"] */ "/app/src/components/index/sections/hero/LazyWatchDogPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegistrationLink"] */ "/app/src/components/RegistrationLink.tsx");
